// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading__2QGVy"};